import bobLogo from "../assets/bob-logo1.jpg";
import pnbLogo from "../assets/pnb.jpg";
import sagarsoftLogo from "../assets/sagarsoft-logo.png";


import bobFavicon from "../assets/bob-logo.png";
import pnbFavicon from "../assets/pnb-logo.png";
import sagarsoftFavicon from "../assets/5.png";
import sagarsoftMain from "../assets/6.png";

import pana from "../assets/pana.png";
import new_bob_logo from "../assets/new_bob_logo.png";

const isBob = window.location.pathname.startsWith("/bob");
const isPnb = window.location.pathname.startsWith("/pnb");
const isSagarsoft = window.location.pathname.startsWith("/sagarsoft");

export const PORTALS = {
   sagarsoft: {
    logo: sagarsoftFavicon,
    appLogo: sagarsoftMain,
    image: pana,
    title: "Welcome to Candidate Portal",
    loginTitle: "Welcome to Candidate Portal",
    footerText: "Sagarsoft",
    // primaryColor: "#ea7c2e", 
     primaryColor: "#208BBD",        
    primaryBackgroundColor: "#3498DB",
    secondaryColor: "#64B5F6",
    textColor: "#333333",
    buttonTextColor: "#FFFFFF",
    appTitle: "Sagarsoft Candidates",
    favicon: sagarsoftLogo,
    infoTextColor: "#1976D2",
  },

  bob: {
    logo: bobLogo,
    appLogo: new_bob_logo,
    image: pana,
    title: "Welcome to BOB Candidate ",
    loginTitle: "Welcome to BOB Candidate Login",
    footerText: "Bank of Baroda",
    primaryColor: "#FF7043",
    primaryBackgroundColor: "#F36F21",
    textColor: "#333333",
    buttonTextColor: "#FFFFFF",
    appTitle: "BOB Candidates",
    favicon: bobFavicon,
    infoTextColor: "rgb(255, 112, 67)",
  },

  pnb: {
    logo: pnbLogo,
    appLogo: pnbLogo,
    image: pana,
    title: "Welcome to PNB Candidate ",
    loginTitle: "Welcome to PNB Candidate Portal",
    footerText: "Punjab National Bank",
    primaryColor: "#FDBD30",
    primaryBackgroundColor: "rgb(162, 10, 58)",
    secondaryColor: "#F9C400",
    textColor: "#333333",
    buttonTextColor: "#FFFFFF",
    appTitle: "PNB Candidates",
    favicon: pnbFavicon,
    infoTextColor: "#FDBD30",
  }, 
};


const getPortal = () => {
  if (isPnb) return "pnb";
  if (isSagarsoft) return "sagarsoft";
  if (isBob) return "bob";
  return localStorage.getItem("portal") || "sagarsoft";
};

export const portal = getPortal();

export const config = PORTALS[portal];